<template>
  <div>
    <blocTypeUser
      v-for="data in datas"
      :titre="data.nom"
      :template="!!data.template"
      :key="data.id"
      :data-id="data.id"
      :linkOnly="true"
      :blocLink="'/mes-tableaux/' + data.id"
      @editProject="handleEditProject"
      @deleteProject="handleDeleteProject"
    ></blocTypeUser>
  </div>
</template>
<script>
import blocTypeUser from '../../components/utils/blocTypeUser'
import blocHeaderTitle from '../../components/utils/blocHeaderTitle'
export default {
  props: {
    datas: {
      type: Array
    }
  },
  components: {
    blocTypeUser,
    blocHeaderTitle
  },
  methods: {
    handleEditProject (dataid) {
      this.$emit('editProject', dataid)
    },
    handleDeleteProject (dataid) {
      this.$emit('deleteProject', dataid)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/listProjet/index.vue